import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { PieChart as PieIcon } from "lucide-react";
import { CHART, ChartCard, ChartEmpty, Dot, PALETTE, TooltipBox } from "./ui";

const CustomTooltip = ({ active, payload }: any) => {
  if (!active || !payload || payload.length === 0) return null;
  const d = payload[0];
  return (
    <TooltipBox title={d.name}>
      <span>{d.value.toLocaleString()} ({((d.value / d.payload.total) * 100).toFixed(1)}%)</span>
    </TooltipBox>
  );
};

const DonutChart = ({ title, data, centerLabel }: any) => {
  const total = (data || []).reduce((sum, d) => sum + (d.value || 0), 0);
  const card = (body) => (
    <ChartCard icon={<PieIcon />} title={title} description={`Split of ${centerLabel || "items"} by type.`}>{body}</ChartCard>
  );
  if (!data || data.length === 0 || total === 0) {
    return card(<ChartEmpty icon={<PieIcon />} text="No data available" />);
  }

  const chartData = data.map((d, idx) => ({ name: d.label, value: d.value || 0, total, color: PALETTE[idx % PALETTE.length] }));

  return card(
    <div className="flex flex-wrap items-center gap-4">
      <div className="h-[200px] min-w-[180px] flex-1">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={chartData} cx="50%" cy="50%" innerRadius={50} outerRadius={80} paddingAngle={2} dataKey="value" stroke={CHART.surface}>
              {chartData.map((entry, idx) => <Cell key={idx} fill={entry.color} />)}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <ul className="donut-legend flex min-w-[180px] flex-1 flex-col gap-2 text-sm">
        {chartData.map((entry) => (
          <li key={entry.name} className="donut-legend-item flex items-center gap-2">
            <Dot color={entry.color} />
            <span className="donut-legend-label min-w-0 flex-1 truncate">{entry.name}</span>
            <span className="donut-legend-value font-semibold tabular-nums">{entry.value.toLocaleString()}</span>
            <span className="donut-legend-pct text-xs text-muted-foreground">({((entry.value / total) * 100).toFixed(1)}%)</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DonutChart;
